module.exports = __webpack_public_path__ + "img/image.8e9b4045.png";